// クライアントサイドでのステータス計算関数

// ストリームのステータス判定
export const getStreamStatus = (stream) => {
  // APIのstatusフィールドのみ使用
  return stream.status || 'upcoming';
};

export const calculateStreamStatus = (stream, selectedDate) => {
  // APIから取得した生のステータス情報をチェック
  if (stream.apiStatus === 'live' || stream.liveBroadcastContent === 'live') {
    const startTime = new Date(stream.startTime);
    const actualToday = new Date();
    const selectedDay = new Date(selectedDate);
    
    // 日付のみで比較（時間は無視）
    const actualTodayDate = new Date(actualToday);
    actualTodayDate.setHours(0, 0, 0, 0);
    const selectedDayDate = new Date(selectedDay);
    selectedDayDate.setHours(0, 0, 0, 0);
    
    // 選択された日付が実際の今日より未来なら全てupcoming
    if (selectedDayDate > actualTodayDate) {
      return 'upcoming';
    }
    
    // 選択された日付以前の配信のみON AIR対象
    const selectedBaseDate = new Date(selectedDate);
    selectedBaseDate.setHours(23, 59, 59, 999);
    if (startTime <= selectedBaseDate) {
      return 'live';
    }
    
    return 'upcoming';
  }
  
  // それ以外は全て'upcoming'
  return 'upcoming';
};

// 配信データ配列のステータスを一括計算
export const calculateAllStreamStatuses = (streams, selectedDate) => {
  return streams.map(stream => ({
    ...stream,
    status: calculateStreamStatus(stream, selectedDate)
  }));
};
